// extracted by mini-css-extract-plugin
export default {"bento__container":"styles_bento__container__NI9K6"};